export default __webpack_public_path__ + "static/media/Stay22.b5b7bc1c.png";